<div class="card-title-block-non-sticky" *ngIf="isShipmentNotFound && !isLoading">
	<copo-back-button></copo-back-button>
	<span class="card-title-label" translate>shipment-card.data-not-found</span>
</div>
<div [copoScroller]="{restoreAfterViewInit: false}" #scroller="copoScroller" class="sidenav-content" @routeAnimation>
	<ng-container *ngIf="!isOffline; else offline">
		<ng-container *ngIf="!isLoading else loading">
			<ng-container *ngIf="shipment">
				<div class="card-title-block-non-sticky">
					<copo-back-button></copo-back-button>
					<div class="card-title-label" translate>shipment.card</div>
				</div>
				<div class="grid-6 copo-container footer-margin" copoAfterViewInit
					(afterviewinit)="scroller.restoreState()">
					<div class="grid-column-one-full">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate>shipment.card.information</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="card-content-block">
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.dispatch-advice-number</div>
										<div class="card-content-value"> {{ shipment.dispatchAdviceNumber }} </div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>datacenter-shipment.dispatch-advice-date</div>
										<div class="card-content-value"> {{ shipment.dispatchAdviceDate}}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>datacenter-shipment.transport-reference</div>
										<div class="card-content-value"> {{ distinctConcatValues(shipment.transportReferenceConcat)}} </div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>shipment.dispatch-date</div>
										<div class="card-content-value"> {{ distinctConcatValues(shipment.shipmentReferenceDate)}} </div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.mill</div>
										<div class="card-content-value"> {{ shipment.millDescription}} </div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>order.ship.to</div>
										<div class="card-content-value"> {{ shipment.destinationDescription }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>commercial-documents.soldto</div>
										<div class="card-content-value"> {{ shipment.soldToDescription}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>eoffer.transport.mode</div>
										<div class="card-content-value"> {{ shipment.transportModeDescription}}</div>
								</div>
							</div>

						</div>
						</mat-expansion-panel>
					</div>
					<div class="grid-column-one-full" *ngIf="documentBoxDisplayed">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span>
									<span translate>order-card.commercial-documents</span>&nbsp;
									<span *ngIf="shipmentCommercialDocCount">({{ shipmentCommercialDocCount }})</span>
									</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="copo-card-grid-container card-grid-padding" *ngIf="!isDocumentLoading else loading">
								<ag-grid-angular *ngIf="gridCommercialDocumentsOptions" class="ag-theme-balham" [gridOptions]="gridCommercialDocumentsOptions"
								[overlayNoRowsTemplate]="overlayNoRowsTemplate" [modules]="agGridModules" (gridReady)="onGridReady($event)"
								(viewportChanged)="onViewportChanged($event)"></ag-grid-angular>
								<div *ngIf="!isDocumentLoading && !gridCommercialDocumentsOptions" class="document-error-box">
									<div translate>order-card.due-to-technical-issue</div>
									<mat-icon class="error-icon" svgIcon="md:running_with_error"></mat-icon>
									<div translate>order-card.we-are-actively-working</div>
								</div>
							</div>
						</mat-expansion-panel>
					</div>
					<div class="grid-column-one-full"
						*ngIf="shipmentBatchesOptions">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span>
									<span translate>datacenter.batch</span>&nbsp;
									<span *ngIf="shipmentBatchCount">({{ shipmentBatchCount }})</span>
									</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
						<div class="copo-card-grid-container card-grid-padding">
							<ag-grid-angular class="ag-theme-balham" [gridOptions]="shipmentBatchesOptions"
								[modules]="agGridModules" (gridReady)="onGridReady($event)"
								(viewportChanged)="onViewportChanged($event)"></ag-grid-angular>
						</div>
						</mat-expansion-panel>
					</div>
				</div>
			</ng-container>
		</ng-container>
	</ng-container>
	<ng-template #offline>
		<copo-offline></copo-offline>
	</ng-template>
	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>
</div>
